import React, { useState } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import PortalHeader from '../../components/Portal/PortalHeader';
import ImportLessons from '../../components/EmployeePortal/ImportLessons';
import CleanupData from '../../components/EmployeePortal/CleanupData';

const ImportLessonsPage = () => {
	const navigate = useNavigate();
	const [activeTab, setActiveTab] = useState('import');

	const handleImportComplete = () => {
		// Redirect to manage lessons page after successful import
		setTimeout(() => {
			navigate('/portal/work/manage-lessons');
		}, 2000);
	};

	return (
		<>
			<PortalHeader
				title='Import Lessons'
				subtitle='Import lesson schedule from MyMusicStaff ICS calendar file.'
			/>
			<Container className='py-4'>
				<Tabs
					activeKey={activeTab}
					onSelect={(k) => setActiveTab(k)}
					className='mb-4'
				>
					<Tab eventKey='import' title='Import Lessons'>
						<ImportLessons onImportComplete={handleImportComplete} />
					</Tab>
					<Tab
						eventKey='cleanup'
						title={
							<>
								<FontAwesomeIcon icon={faTrash} className='me-1' />
								Data Cleanup
							</>
						}
					>
						<CleanupData />
					</Tab>
				</Tabs>
			</Container>
		</>
	);
};

export default ImportLessonsPage;
